import { useEffect, useState } from "react";

const DARK_MODE_RELEASE_MODAL_HIDE_UNTIL_KEY = "dark-mode-release-modal-hide-until";

export const useDarkModeReleaseModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Don't show modal after October 17, 2025
    const endDate = new Date("2025-10-17T00:00:00");
    const now = new Date();

    if (now >= endDate) {
      setIsOpen(false);
      setIsLoaded(true);
      return;
    }

    // Check if modal is temporarily hidden for today
    const hideUntilStr = localStorage.getItem(DARK_MODE_RELEASE_MODAL_HIDE_UNTIL_KEY);

    if (hideUntilStr) {
      const hideUntil = parseInt(hideUntilStr, 10);
      const nowTimestamp = Date.now();

      if (nowTimestamp < hideUntil) {
        // Still within the "hide for one week" period
        setIsOpen(false);
        setIsLoaded(true);
        return;
      } else {
        // Period expired, clear the temporary hide
        localStorage.removeItem(DARK_MODE_RELEASE_MODAL_HIDE_UNTIL_KEY);
      }
    }

    // Show the modal
    setIsOpen(true);
    setIsLoaded(true);
  }, []);

  const closeModal = () => {
    setIsOpen(false);
    // Just close the modal without storing anything - it will reappear on next refresh
  };

  const hideForToday = () => {
    setIsOpen(false);
    // Calculate timestamp for one week from now
    const now = new Date();
    const oneWeekFromNow = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000);
    localStorage.setItem(DARK_MODE_RELEASE_MODAL_HIDE_UNTIL_KEY, oneWeekFromNow.getTime().toString());
  };

  const resetModal = () => {
    localStorage.removeItem(DARK_MODE_RELEASE_MODAL_HIDE_UNTIL_KEY);
    setIsOpen(true);
  };

  return {
    isOpen,
    isLoaded,
    closeModal,
    hideForToday,
    resetModal,
  };
};
